import React from 'react';

const ExtraHomepageContentBottom = (props) => {
  return <></>;
};
export default ExtraHomepageContentBottom;
